import { useEffect } from 'react';

/** Refetch when the browser restores this page from the back-forward cache. */
export function useReloadOnPageRestore(onRestore) {
    useEffect(() => {
        const handler = (event) => {
            if (event.persisted) {
                onRestore();
            }
        };
        window.addEventListener('pageshow', handler);
        return () => window.removeEventListener('pageshow', handler);
    }, [onRestore]);
}
